import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <Alert variant="destructive" className="max-w-md">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>出错了</AlertTitle>
        <AlertDescription className="flex flex-col gap-4">
          <p>{message}</p>
          {onRetry && (
            <Button size="sm" variant="outline" onClick={onRetry} className="w-fit">
              重试
            </Button>
          )}
        </AlertDescription>
      </Alert>
    </div>
  );
}
